import React from "react";
import "./Experience.css";

const experiences = [
  {
    title: "Data and Software Engineer Intern",
    company: "Air Liquide",
    location: "Paris, France",
    year: "Apr - Oct 2025",
    key_words: [
        "Python",
        "XGBoost",
        "Predictive Modeling",
        "Data Pipelines",
        "Industrial Data",
        "MLOps"
    ],
    description: (
        <>
            <li>Designed and deployed a <b>predictive model (Python, XGBoost)</b> to forecast water-quality indicators for <b>industrial plants</b>.</li>
            <li>Built <b>reproducible data pipelines</b> and collaborated with engineers to ensure industrial relevance.</li>
            <li>Delivered a <b>production-ready model</b> with automated retraining and clear documentation.</li>
        </>
    )
  },
  {
    title: "Software Engineer Intern",
    company: "Algolight (Start-up)",
    location: "Saint-Nazaire, France",
    year: "Jul - Aug 2024",
    key_words: [
        "Python",
        "Django",
        "Raspberry Pi",
        "Real-Time Systems",
        "IoT",
        "Biotech"
    ],
    description: (
        <>
            <li>Bridged <b>software and biology</b> by developing a <b>real-time photobioreactor control system</b> (Python/Django, Raspberry Pi).</li>
            <li>Collaborated with biologists and engineers to digitize experimental workflows, enabling continuous monitoring and reducing manual interventions.</li>
        </>
    )
    }    
];

const Experience = () => {
  return (
    <section id="experience" className="experience-section">
      <h2 className="experience-heading">Experience</h2>

      <div className="timeline">
        {experiences.map((exp, index) => (
          <div className="timeline-item" key={index}>
            
            {/* Le point sur la timeline */}
            <div className="timeline-point" />

            {/* La carte */}
            <div className="timeline-card">
              <h3 className="timeline-title">{exp.company} - {exp.title}</h3>
              <p className="timeline-subtitle">
                {exp.year} / {exp.location}
              </p>
              {/* --- Badges --- */}
              <ul className="experience-badges">
                {exp.key_words.map((kw, i) => (
                  <li key={i} className="badge">
                    {kw}
                  </li>
                ))}
              </ul>

              {/* --- Description --- */}
              <div className="timeline-details">
                {exp.description}
              </div>

            </div>

          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;